<template>
  <div style="height:90%;width:100%;position:relative;">
    <div id="aaa" style="width:100%;height:80%;position:absolute;bottom:48px;"></div>
    <div class="title-list">
      <span class="span-icon icon1"></span>
      <span class="span-text">投放任务量</span>

    </div>
  </div>
</template>
<script>
import echarts from 'echarts'

export default {
  data() {
    return {
      month: [],
      num: [],
      initOption: {
        size: {
          width: '800px',
          height: '300px'
        },
        //柱状图宽度
        barWidth: '5px',
        lableList: ['2022-02', '2022-03', '2022-04', '2022-05', '2022-06', '2022-07', '2022-08'],
        dataList: [1, 2, 0, 0, 0, 0, 0, 0, 1, 0]
      },
      yAxisMax: 5,
    }
  },
  methods: {
    initData(_obj) {
      this.month = _obj.lableList;
      this.num = _obj.dataList;
      // 本地测试数据
      // this.month = this.initOption.lableList;
      // this.num = this.initOption.dataList;
      if (this.num && this.num.length > 0) {
        let max = this.num.reduce((num1, num2) => num1 > num2 ? num1 : num2);
        this.yAxisMax = max >= 5 ? max : 5;
      }
      this.drawChart()
    },
    //生成随机字符串
    drawChart() {
      const _this = this
      // 初始化实例
      let myChart = echarts.init(document.getElementById('aaa'));
      // 指定图表的配置项和数据
      let option = {
        //柱状图颜色
        color: "#05A7EA",
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter(params) {
            return `时间：${params[0].name}<br/>任务量：${params[0].value}`
          },
          backgroundColor: 'rgba(50,50,50,0.3)'
        },
        legend: {
          data: ['2011年'],
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          width: '100%',
          height: '90%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          //坐标轴
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(0,0,0,0.15)",
            }
          },
          //刻度文字
          axisLabel: {
            show: true,
            color: "rgba(0,0,0,0.45)"
          },
          //刻度
          axisTick: {
            show: false
          },
          data: this.month,

        },
        yAxis: {
          type: 'value',
          name: "任务量",
          minInterval: 1,
          max: this.yAxisMax,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            color: "rgba(0,0,0,0.45)"
          },
          //网格线
          splitLine: {
            show: true,
            lineStyle: {
              type: 'solid',
              color: "rgba(0,0,0,0.1)"
            }
          },
        },
        series: [{
          data: this.num,
          type: 'line'
        }]
      };
      //使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      setTimeout(function () {
        window.onresize = function () {
          myChart.resize();
        }
      }, 200)
    }
  }
};
</script>
<style lang="scss" scoped>
.title-list {
  height: 20px;
  text-align: center;
  line-height: 12px;
  font-size: 12px;
  position: absolute;
  bottom: 0px;
  left: 44%;
  color: rgba(0, 0, 0, 0.65);

  span {
    display: inline-block;
    margin-right: 4px;
  }

  .icon1 {
    background: #05A7EA;
  }

  .span-icon {
    height: 8px;
    width: 8px;
    border-radius: 2px;
  }
}
</style>